<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <div :class="'text-center welcome-card is-' + $device">
            <div style="margin: auto 0; position: relative">
                <div style="background-color: #fff; padding: 16px">
                    <!-- <div @click="closeWelcome">
                    <label class="custom-close w-100 fs-16"> x close </label>
                </div> -->
                    <label class="ยินดีต้อนรับ fs-20"> ยินดีต้อนรับ </label>
                    <div style="position: relative">
                        <img src="../../../public/resources/images/member-card.png" style="margin-top: 12px; width: 90%" />
                        <!-- <label class="privilege-card-label fs-18"> PRIVILEGE CARD </label> -->
                        <div class="member-id-label">
                            <span class="fs-18" style="letter-spacing: 5px">{{ user.member_id ? user.member_id.replace(/-/g, '') : '' }}</span>
                            <br />
                            <span class="fs-16" style="display: flex">{{ user.custodian_name }}</span>
                        </div>
                    </div>
                    <label class="ขอต้อนรับท่านเข้าสู่ fs-18"> ขอต้อนรับท่านเข้าสู่ </label>
                    <label class="SCGDCWA fs-18"> SCG Debenture Club<br />Web Application </label>
                    <label class="สิทธิประโยชน์ fs-18">
                        สิทธิประโยชน์เหนือระดับ
                        <br />
                        สำหรับผู้ถือหุ้นกู้
                        <br />
                        ของบริษัทปูนซิเมนต์ไทย จำกัด (มหาชน)
                        <br />และ/หรือบริษัทในกลุ่ม
                    </label>
                </div>
                <a-button size="large" class="text-center cancel-btn br-20 mt-20" @click="closeWelcome">
                    <span class="fs-18 fw-600">ปิดหน้าต่าง</span>
                </a-button>
            </div>
        </div>
    </a-spin>
</template>
<script>
export default {
    data: function () {
        return {
            getting_data: true,
            user_detail: [],
            popup: this.$route.query.popup,
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    mounted() {
        this._mounted();
    },
    methods: {
        _mounted: function () {
            this.getUserDetail(() => this.getConsent(() => this.getConsent2(() => (this.getting_data = false))));
        },
        getUserDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/checkLogin',
                    data: {
                        // member_id: Number(this.user.member_id.replace(/-/g, '')),
                    },
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            this.user_detail = res.complete;
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        getConsent: function (callback = null) {
            this.$store.dispatch('user/GET', {
                payload: {
                    path: '/api/consent',
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            this.consent = res.complete;
                            if (this.user_detail && this.user_detail.consent_id != res.complete.consent_id) {
                                this.$router.push({
                                    path: '/terms',
                                    query: { accept: 1, popup: this.popup },
                                });
                            }
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        getConsent2: function (callback = null) {
            this.$store.dispatch('user/GET', {
                payload: {
                    path: '/api/consent2',
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            if (this.user_detail && this.user_detail.consent2_id != res.complete.consent2_id) {
                                this.$router.push({
                                    path: '/privacy-policy',
                                    query: { accept: 1, consent_id: this.consent.consent_id, popup: this.popup },
                                });
                            }
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        closeWelcome() {
            if (this.popup && this.popup.length) {
                this.$router.replace({
                    path: '/popup',
                    query: {
                        popup: this.popup,
                    },
                });
            } else {
                this.$router.replace({
                    path: '/home',
                });
            }
        },
    },
};
</script>
<style scoped>
.custom-close {
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.ยินดีต้อนรับ {
    margin: 0;
    font-weight: 600;
}
.privilege-card-label {
    margin: 0;
    position: absolute;
    left: 47%;
    bottom: 37%;
    filter: opacity(0.9);
    color: #d3d4d5 !important;
}
.member-id-label {
    margin: 0;
    position: absolute;
    left: 12%;
    bottom: 10%;
    color: #fff !important;
}
.custodian-name-label {
    margin: 0;
    position: absolute;
    left: 12%;
    bottom: 8%;
    color: #fff !important;
}
.ขอต้อนรับท่านเข้าสู่ {
    margin: 0;
    margin-top: 16px;
    font-weight: 600;
}
.SCGDCWA {
    margin: 0;
    margin-top: 16px;
    color: #cc0000 !important;
    width: 90%;
    font-weight: 600;
    padding: 0 26px;
}
.สิทธิประโยชน์ {
    margin: 0;
    margin-top: 16px;
    font-weight: 600;
    padding: 0 26px;
}
.welcome-card {
    display: flex;
    width: 100%;
    height: 100vh;
    margin: 0 auto;
}
/* .welcome-card.is-desktop,
.welcome-card.is-tablet {
    width: 25%;
    min-width: 384px;
} */
@media (max-device-width: 480px) {
    .welcome-card {
        width: 90%;
    }
}
@media (max-device-width: 413px) {
    .privilege-card-label,
    .ขอต้อนรับท่านเข้าสู่,
    .SCGDCWA,
    .สิทธิประโยชน์ {
        left: 44%;
    }
}
</style>